module.exports = __webpack_public_path__ + "static/media/club-1.67dde341.png";